var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.497.583A7.911 7.911 0 0 0 .584 8.5a7.911 7.911 0 0 0 7.913 7.917 7.918 7.918 0 1 0 0-15.834Zm.004 14.25A6.332 6.332 0 0 1 2.167 8.5c0-3.499 2.834-6.333 6.334-6.333C12 2.167 14.834 5 14.834 8.5c0 3.5-2.834 6.334-6.333 6.334Zm.395-10.291H7.71v4.75l4.152 2.494.598-.974-3.563-2.114V4.542Z",
    fill: "#3483DF"
  })));
};
export default SvgClock;